import { isEmpty, isFunction } from 'lodash';

import { IPdfDefinitions } from '../pdf.type';

const isBulkPdf = (pdfDefine: IPdfDefinitions): boolean =>
  !isEmpty(pdfDefine?.bulkOptions?.data) ||
  isFunction(pdfDefine?.bulkOptions?.data);

export { isBulkPdf };
